import { Cols } from "../../shared/Consts";
import SummaryFixed from "./SummaryFixed";
import HistoryTitle from "./HistoryTitle";

import _ from "lodash";
import usePortfolio from "../../hooks/PortfolioProvider";
import { usePath } from "../../libs/path/PathProvider";
import PortUtils from "../../portlibs/PortUtils";
import HistoryFilter, { useHistoryFilter } from "../../components/HistoryFilter";
import TransactionTable from "../../components/TransactionTable";
import { IHistoryProps } from "../History";

const GICCols = [Cols.date, Cols.maturity, Cols.accountId, Cols.type, Cols.id, Cols.yield, Cols.total, Cols.gain, Cols.note]
const BondCols = [Cols.date, Cols.maturity, Cols.accountId, Cols.type, Cols.id, Cols.yield, Cols.price, Cols.total, Cols.gain, Cols.note]

export default function History(props:IHistoryProps){
    const {query} = usePath();
    const {portfolio} = usePortfolio()

    const holding = portfolio.holding(props.ticker)!.filterByAccount(PortUtils.getFilter(query).account)
    const historyFilter = useHistoryFilter()

    const rows = PortUtils.filterTransactions(holding.transactions, historyFilter, true)

    const cols = holding.isBond ? BondCols : GICCols
    const table = <TransactionTable tableName="gic_trans" {...props} rows={rows} cols={cols}/>
    return <>
        <HistoryTitle holding={holding} transactions={rows} cols={cols}/>
        <SummaryFixed holding={holding}/>
        <div className="flex gap-8 flex-wrap"><HistoryFilter/></div>
        <div className="scrollRect">{table}</div>
    </>
}